import { VhcRecordLogService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

type VhcRecordsEmailProps = {
  id: number;
};

export const useVhcRecordsReportEmailMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof VhcRecordLogService.postVhcRecordsReportEmail>>,
      QueryError,
      VhcRecordsEmailProps,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ id }: VhcRecordsEmailProps) => {
      return VhcRecordLogService.postVhcRecordsReportEmail(id);
    },
    {
      ...options,
      onSuccess: () => {
        toast.success('Successfully Send!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
